

<!-- Start About Us Area -->
<div class="about-us-area ptb-100">
    <div class="container">
        <div class="row align-items-center">
         
            <div class="col-lg-8 col-md-12 ">
                <div class="about-us-content">
                    <span>Mission and Vision </span>
                    <h2 class="about-us_title">Shaping the Future of IT Leadership</h2>
                    <p>At RoundtableCXO, our mission is to cultivate a trusted peer network where senior IT leaders can openly exchange ideas, gain practical insights, and build valuable relationships. Through thoughtfully curated, small-format events, we bring together technology executives across industries to explore challenges, share solutions, and elevate the role of IT in driving business success. </p>
                    <p>We aim to become the go-to community for technology leaders seeking fresh thinking, cross-industry perspectives, and meaningful collaboration. Our roundtables are designed to serve as real-world think tanks — places where innovation, leadership, and strategy converge. By creating space for open dialogue and mutual learning, we empower IT executives to lead with greater impact and shape the future of enterprise technology. </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-12 ">
                <div class="about-us-image">
                    <div class="image-two">
                        <img src="assets/images/about/about-1.png" alt="image">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End About Us Area -->
